export class ContactInfoFieldDataResultDto {
  fieldName: string;
  fieldValue: string;
  info: string;
}
